<template>
  <div>
    <div class="flex justify-between">
      <div>
        <span class="text-xl text-red-500">Zona de perigo</span>
      </div>
      <div>
        <span
          class="cursor-pointer"
          @click="openConfirm = true"
        >
        </span>
      </div>
    </div>
    <div class="mt-5 md:mt-0 md:col-span-2 ">
      <div class="shadow overflow-hidden sm:rounded-md my-6">
        <div class="px-4 py-5 md:py-8 bg-white flex">
          <div class="md:ml-auto">
            <el-button
              type="danger"
              size="mini"
              @click="openConfirm = true"
            >
              <i class="fas fa-exclamation-triangle px-2"></i>
              {{label}}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <jet-confirmation-modal
      :show="openConfirm"
      :closeable="false"
      @close="openConfirm = false"
    >
      <template #title>
        {{label}}
      </template>
      <template #content>
        <div class="mt-2 ">
          <div>
            <span>
              Tem certeza que deseja excluir ?
            </span>
          </div>
          <div>
            <span class="text-red-600"> O registro será removido permanentemente.</span>
          </div>
          <jet-input-error
            :message="form.errors.id"
            class="mt-2"
          />
          <jet-action-message
            :on="form.recentlySuccessful"
            class="mr-3"
          >
            <span class="bg-green-200"> Registro excluído com sucesso</span>
          </jet-action-message>
        </div>

      </template>
      <template #footer>
        <div class="flex justify-around ">
          <el-button
            type="primary"
            class="w-60"
            @click="openConfirm= false"
          >Cancelar Exclusão</el-button>
          <el-button
            type="danger"
            class="w-60"
            @click="destroy"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          > <i class="fas fa-exclamation-triangle px-2"></i>{{label}}</el-button>
        </div>
      </template>
    </jet-confirmation-modal>
  </div>
</template>

<script>
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetInputError from '@/Jetstream/InputError';
import JetActionMessage from '@/Jetstream/ActionMessage';

export default {
  props:
  {
    identificador: [String, Number],
    rota: String,
    label: String,
  },
  components: { JetConfirmationModal, JetInputError, JetActionMessage },
  data() {
    return {
      openConfirm: false,
      isLoading: false,
      form: this.$inertia.form({
        id: this.identificador
      })
    }
  },
  methods: {
    async destroy() {
      this.form.delete(this.rota, {
        preserveScroll: true
      });
    }
  }
}
</script>

<style scoped>
</style>
